import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BookingsDashboardInput, Detail, WaitListDashboardRequest, WaitlistItem } from '../../../../models/bookings.model';
import { SortOrder } from '../../../../models/common.enums';
import { DashboardFeature } from '../../../../models/dashboard-common.model';
import { InOfficeDashboardRequest, MeetingWaitlist, VirtualBookings, VirtualDashboardRequest } from '../../../../models/meetings.model';
import { BookingDashboardSorting } from '../../../../pages/bookings/all-bookings/components/bookings-dashboard/bookings.model';
import { BookingsService } from '../../../../services/APIs/Bookings/bookings.service';
import { MeetingsService } from '../../../../services/APIs/Meetings/meetings.service';
import { UserSettingsService } from '../../../../services/user-settings.service';
@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {

  constructor(private bookingService: BookingsService, private meetingService: MeetingsService, private userSettingService: UserSettingsService,) { }

  getGlobalSearchData(term: string): Observable<GlobalSearchResponse> {
    const input ={
      startDate : moment(new Date().setHours(0, 0, 0)).subtract(30, 'days').format('YYYY-MM-DDTHH:mm:ss'),
      endDate :moment(new Date('2099-12-31T23:59:00')).format('YYYY-MM-DDTHH:mm:ss'),
      term :term,
      limit: this.userSettingService.appSettings.GlobalSearchLimit,
    };
    return forkJoin({
      bookings: this.bookingService.getBookingsDashboardData(this.createBookingDashboardInput(input), false).pipe(
        map(res=>res.items as Detail[])
      ),
      //Phase 1 - commenting virtual dashboard call in global search
      meetingRequests: this.meetingService.getInOfficeDashboardData(this.createInOfficeInput(input), false).pipe(
        map(res => res.items as MeetingWaitlist[])
      ),
      // virtualRequests: this.meetingService.getVirtualDashboardData(this.createVirtualRequestInput(input), false).pipe(
      //   map(res => res.items as VirtualBookings[])
      // ),
      waitlists: this.bookingService.getWaitListDashboardData(this.createWaitlistInput(input), false).pipe(
        map(res => res.items as WaitlistItem[])
      )
    })
  }

  private createBookingDashboardInput(obj): BookingsDashboardInput {
    const input: BookingsDashboardInput = {      
      ...obj,
      bookingDashboardSortings: [{
        property: BookingDashboardSorting.StartDate.toString(),
        order: SortOrder.Desc
      }],
      features: DashboardFeature.IncludeTotalCount
    }
    return input;
  }

  private createInOfficeInput(obj): InOfficeDashboardRequest {
    const input: InOfficeDashboardRequest = {
      ...obj,
      meetingWaitListSorting: [{
        meetingWaitListSortingType:1 ,
        orderType: SortOrder.Desc
      }]     
    }
    return input;
  }

  private createVirtualRequestInput(obj): VirtualDashboardRequest {
    const input: VirtualDashboardRequest = {
      ...obj,
      virtualBookingDashboardSortings: [{
        property: 'StartDate',
        order: SortOrder.Desc
        }]
    }
    return input;
  }
  private createWaitlistInput(obj): WaitListDashboardRequest {
    const input: WaitListDashboardRequest = {
      StartDate: obj.startDate,
      EndDate: obj.endDate,
      Term: obj.term,
      Limit: obj.limit,
    }
    return input;

  }
}

export interface GlobalSearchResponse {
  bookings?: Detail[];
  meetingRequests?: MeetingWaitlist[];
  virtualRequests?: VirtualBookings[];
  waitlists?: WaitlistItem[];
}
